import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ThankYouRegistration = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                backgroundColor: '#FAFAFA',
                textAlign: 'center',
                padding: '20px',
            }}
        >
            <Box
                sx={{
                    maxWidth: '420px',
                    width: '100%',
                    backgroundColor: 'white',
                    padding: '24px',
                    borderRadius: '8px',
                    boxShadow: 3,
                    textAlign: 'center'
                }}
            >
                <Typography variant='h5' sx={{ marginBottom: '16px' }}>Registration Submitted</Typography>
                <Typography sx={{ marginBottom: '24px', color: 'rgba(0, 0, 0, 0.7)' }}>
                    Thank you for registering! Your request has been received.  
                    Please keep an eye on your email for further updates.
                </Typography>
                <Button
                    fullWidth
                    variant='contained'
                    sx={{ backgroundColor: '#673AB7', color: 'white' }}
                    onClick={() => navigate('/')}
                >
                    Return to Login
                </Button>
            </Box>
        </Box>
    );
};

export default ThankYouRegistration;